import { TabsContent } from "@/components/ui/tabs";
import { cn } from "@/utils/utils";
import { TabsContentProps } from "@radix-ui/react-tabs";

export const SheetTabsContent = ({ className, ...props }: TabsContentProps) => {
  return (
    <TabsContent
      className={cn(
        "flex flex-1 flex-col overflow-y-auto p-sheet-gap scrollbar-thin data-[state=inactive]:hidden",
        className,
      )}
      {...props}
    />
  );
};
